import React, {useEffect, useState} from "react"
import {getUserEmail, millisecToDatePicker, UI_LISTED_ELEMENTS_LIMIT} from "../prodect/ProsConnect"
import Intro from "./Intro";
import {USE_DEVELOPMENT_FEATURES} from "../config";
import {UiIcon, STATE_ICON_CLASSES} from "../prodect/ProsCommonUi";
import {MAIN_VIEW_SETTINGS} from "./Home";
import BasicButton from "../components/BasicButton";
import * as prosConnect from "../prodect/ProsConnect";
import LoadingAnimation from "../components/LoadingAnimation";

function StartPage(props) {
    const [userdata, setUserdata] = useState(null)

    useEffect(() => {
        async function getUserInfo() {
            setUserdata({
                last_login: millisecToDatePicker(new Date(Date.now()))
            })
        }
        getUserInfo()
    }, [])

    function ancientOldTimerPage(){
        return <>
            <header className="page-header">
                <h1>Aloitus</h1>
            </header>
            <section className={"content content-welcome flex-center text-center width-100 padding"}>
                <div className={"message"}>
                    <div>
                        <img className={"welcome-img"} src={"/images/welcome-screen.svg"} alt={""}/>
                        <h1>Tervetuloa!</h1>
                        <p>Voit katsoa käyttöohjeita sivupalkin 'Näytä ohje' -painikkeesta.</p>
                    </div>
                </div>
                <div>
                    <p>Olet kirjautuneena tunnuksella <strong>{getUserEmail(true)}.</strong></p>
                </div>
            </section>
        </>
    }
    if(!USE_DEVELOPMENT_FEATURES) return ancientOldTimerPage()

    function createRandomString(length) {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789"
        let result = "";
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length))
        }
        return result
    }

    function renderTile(item, ind){
        function renderLink() {
            if(!item.view) return null
            return <BasicButton
                btnClass={"primary"}
                icon={"gear"}
                iconColor={item.bg ? "light" : null}
                action={()=> props.setMainView(item.view)}
            />
        }
        return <div
                key={'rt__' + ind}
                className={"tile"}
                style={item.bg ? {
                    backgroundColor: item.bg,
                    color: 'var(--color-light)'
                } : null}
            >
            <header className={"element-set-sm valign-center margin-bottom"}>
                <UiIcon icon={item.icon} color={item.bg ? "light" : null}/>
                <h3 className={"flex-grow margin-0"}>
                    {item.title}
                </h3>
                {renderLink()}
            </header>
            <section
                    className={"element-set-v list-view"}
                >
                {item.renderCallback ? item.renderCallback() : renderFakeStuff()}
            </section>
        </div>
    }

    function renderFakeStuff(){
        const rand = Math.floor(Math.random() * UI_LISTED_ELEMENTS_LIMIT) + 3
        let elemList = []
        for(let i = 1; i <= rand; i++){
            elemList.push(<React.Fragment key={'rfs__' + i}>
                <Obs />
            </React.Fragment>)
        }
        return elemList
    }

    function renderUserInfo (){
        if(!userdata) return <LoadingAnimation color={"var(--color-light)"}/>
        return <>
            <p className={"color-light"}>{prosConnect.getUserName()}<br/>
                {prosConnect.getUserEmail(true)}<br/>
                Viimeksi kirjautunut: {userdata.last_login}
            </p>
        </>
    }
    function renderHistory(){
        return <>
            <h4>Muokatut kirjaukset</h4>
            {renderFakeStuff()}
        </>
    }
    function renderBookmarks(){
        return <>
            <p>List bookmarks...</p>
        </>
    }

    function Obs(props){
        const title = 'Kirjaus ' + createRandomString(Math.floor(Math.random() * UI_LISTED_ELEMENTS_LIMIT) + 6)
        return <div className={"list-view-item"}>
            <div className={"list-view-item-header"}>
                <h3 className={"obs-text"}>
                    {title}
                </h3>
                <span className={"icont-set valign-top"}>
                    <i className={"ui-icon ui-icon-md " + STATE_ICON_CLASSES[Math.floor(Math.random() * STATE_ICON_CLASSES.length)]}/>
                </span>
            </div>
        </div>
    }

    const contentStuff = [
        {
            icon: 'user',
            title: 'Omat tiedot',
            bg: 'var(--color-main-c7)',
            view: MAIN_VIEW_SETTINGS,
            renderCallback: renderUserInfo
        },
        {
            icon: 'star',
            title: 'Seuratut',
            bg: 'var(--color-user-c7)'
        },
        {
            icon: 'bell',
            title: 'Ilmoitukset'
        },
        {
            icon: 'history',
            title: 'Tapahtumat',
            renderCallback: renderHistory
        },
        {
            icon: 'bookmark',
            title: 'Kirjanmerkit',
            renderCallback: renderBookmarks
        }
    ]

    require("./assets/scss/views/CommonViews.scss");
    require("./assets/scss/StartPage.scss");
    return <div className={"content content-startpage"}>
        <div className={"masonry"}>
            {contentStuff.map((item, i) => renderTile(item, i))}
        </div>
        <Intro
            page={1}
        />
    </div>
}

export default StartPage